import React from "react";
import { connect } from "react-redux";


import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import NiveauInstantieForm from "./NiveauInstantieForm";
import NiveaInstantiePageHelper from "./NiveauInstantiePageHelper";
import redirector from "../../../util/redirector";
import * as layoutActions from "../../../actions/layoutActions";

class NiveaInstantiePage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                checkedInstanties: []
            },
            hasUnsavedChanges: false,
            transactieId: null,
            editMode: false,
            instantieToAdd: "",
            instantieToAddHasFocus: false,
            instanties: [],
            originalModel: {
                checkedInstanties: []
            },
            shouldScrollToFirstError: false,
            validationMessageType: '',
            errors: {},
            undoButtonDisabled: true
        };

        this.pageHelper = new NiveaInstantiePageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnAddInstantie = () => this.pageHelper.addInstantie();
    handleOnRemoveInstantie = (index) => this.pageHelper.removeInstantie(index);
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnSave = () => this.pageHelper.save();
    handleOnUndo = () => this.pageHelper.undo();

    render() {
        const state = this.state;
        const props = this.props;
        const model = state.model;
        const instantieToAdd = state.instantieToAdd;
        const instantieToAddHasFocus = state.instantieToAddHasFocus;
        const instanties = props.instanties;
        const models = model.checkedInstanties.sort();
        const disabled = this.props.disabled;

        return (
            <NiveauInstantieForm
                models={models}
                onAddInstantie={this.handleOnAddInstantie}
                onRemoveInstantie={this.handleOnRemoveInstantie}
                onChange={this.handleOnChange}
                onSave={this.handleOnSave}
                options={instanties}
                instantieToAdd={instantieToAdd}
                onUndo={this.handleOnUndo}
                instantieToAddHasFocus={instantieToAddHasFocus}
                undoButtonDisabled={this.state.undoButtonDisabled}
                disabled={disabled}
                organisatieNiveau={props.organisatieNiveau}
                userType={this.props.userType}
                gemeenteNaam={this.props.gemeenteNaam}
                isNew={props.isNew}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        transactionId: state.session.activeTransactionId,
        instanties: state.referentie.niveauInstanties,
        disabled: state.session.readOnly,
        organisatieNiveau: state.session.activeOrganisatieNiveau,
        isNew: state.session.isNew,
        userType: state.session.userType,
        gemeenteNaam: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.naam: null,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NiveaInstantiePage);